export const { REACT_APP_GOOGLE_TRACKING_ID } = process.env;

export const GOOGLE_ADS_ACCOUNT_ID = '9203700535-WEB';

export const getGoogleClientID = (cb) => {
  if (window.ga) {
    window.ga('create', REACT_APP_GOOGLE_TRACKING_ID, 'auto');

    window.ga((tracker) => {
      cb(tracker.get('clientId'));
    });
  }
};
